promokit.layer({
  el: '#layer-coupon',
  buttons: '.p-sec1__detail',
});

export default {
  id: '#section1',
};



// WEBPACK FOOTER //
// ./src/js/bingo/section-1.js